export default __webpack_public_path__ + "static/media/title-deco-right.7f9433a3.webp";